import { createContext, useState } from "react";

import { DropdownItemProps } from "semantic-ui-react";
import { RefreshQueueInsured } from "./types";
import { notImplemented } from "../../services/Library";

export interface RefreshQueueContextProps {
    analysts: DropdownItemProps[] | undefined;
    setAnalysts: (options: DropdownItemProps[]) => void;
    selectedInsured: RefreshQueueInsured | null;
    portfolioOptions: DropdownItemProps[] | undefined;
    setPortfolioOptions: (options: DropdownItemProps[]) => void;
    setSelectedInsured: (insured: RefreshQueueInsured | null) => void;
}

export const RefreshQueueContext = createContext<RefreshQueueContextProps>({
    analysts: undefined,
    setAnalysts: notImplemented,
    portfolioOptions: undefined,
    setPortfolioOptions: notImplemented,
    selectedInsured: null,
    setSelectedInsured: notImplemented
});

export const RefreshQueueContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [analysts, setAnalysts] = useState<DropdownItemProps[]>([]);
    const [portfolioOptions, setPortfolioOptions] = useState<DropdownItemProps[]>([]);
    const [selectedInsured, setSelectedInsured] = useState<RefreshQueueInsured | null>(null);

    return (
        <RefreshQueueContext.Provider
            value={{
                analysts,
                setAnalysts,
                portfolioOptions,
                setPortfolioOptions,
                selectedInsured,
                setSelectedInsured
            }}
        >
            {children}
        </RefreshQueueContext.Provider>
    );
};

export default RefreshQueueContextProvider;
